/**
 * NO04 - Ordre Search Saga
 */

import { put, call } from 'redux-saga/effects';
import * as actionsNO04 from '../actions/indexNO04';
import * as APICalls from '../../felles/APICalls_NO04';
import NO04 from '../../models/NO04';

function getErrorMessage(error: any, fallback: string): string {
  const backendMessage = error?.response?.data?.error;
  return typeof backendMessage === 'string' && backendMessage.trim() ? backendMessage : fallback;
}

function mapToNO04(item: any): NO04 {
  // Sum quantityOrdered and quantityDelivered across all product lines
  const lines: any[] = item.products ?? [];
  const antBestilt = lines.reduce((sum: number, l: any) => sum + (l.quantityOrdered ?? 0), 0);
  const antLevert  = lines.reduce((sum: number, l: any) => sum + (l.quantityDelivered ?? 0), 0);

  return new NO04(
    item.orderNumber       ?? '',   // ordreNr
    item.customerNumber    ?? '',   // kundenr
    item.customerName      ?? '',   // navn
    item.requisitionNumber ?? '',   // rekvNr
    item.orderDate         ?? '',   // dato
    item.orderTime         ?? '',   // tid
    item.receiver          ?? '',   // om (Receiver / OM)
    item.status            ?? '',  // status
    antBestilt,                     // antBestilt
    antLevert,                      // antLevert
    item.totalPrice        ?? 0,    // belop
    item.grossProfit       ?? null, // brfProsent
    item.invoiceCreditNumber ?? '', // faktura
    item.shippingNumber    ?? '',   // fraktEdi (tracking)
    String(item.orderType  ?? ''),  // ordreType
    item.orderPaymentMethod ?? '',  // betalingsKode
    item.shippingMethod    ?? '',   // sendeMote
    item.speditor          ?? '',   // speditor (carrier code)
    String(item.bk         ?? ''),  // bk
  );
}

export function* searchNO04OrdersSaga(action: any) {
  try {
    const paginatedParams = { ...action.payload, page: 0, pageSize: 100 };
    const response = yield call(APICalls.searchOrders, paginatedParams);

    if (response?.data) {
      const raw: any[] = response.data.orders ?? response.data.content ?? [];
      const orders: NO04[] = raw.map(mapToNO04);
      const hasMore = orders.length >= 100;
      yield put(actionsNO04.NO04SearchSuccess(orders, hasMore));
    }
  } catch (error: any) {
    yield put(actionsNO04.NO04SearchFailure(getErrorMessage(error, 'Kunne ikke søke etter ordre. Prøv igjen.')));
  }
}

export function* loadMoreNO04OrdersSaga(action: any) {
  try {
    const response = yield call(APICalls.searchOrders, action.payload);
    if (response?.data) {
      const raw: any[] = response.data.orders ?? response.data.content ?? [];
      const orders: NO04[] = raw.map(mapToNO04);
      yield put(actionsNO04.NO04LoadMoreSuccess(orders, orders.length >= 100));
    }
  } catch (error: any) {
    yield put(actionsNO04.NO04LoadMoreFailure(getErrorMessage(error, 'Kunne ikke laste flere ordre. Prøv igjen.')));
  }
}

export function* fetchNO04OrderDetailSaga(action: any) {
  try {
    const { companyId, orderNumber } = action.payload;
    const response = yield call(APICalls.fetchOrderDetail, companyId, orderNumber);
    yield put(actionsNO04.NO04OrderDetailSuccess(response.data));
  } catch (error: any) {
    yield put(actionsNO04.NO04OrderDetailFailure(getErrorMessage(error, 'Kunne ikke hente ordredetaljer. Prøv igjen.')));
  }
}
